import React from "react";
import { IColProps } from "./ColProps";
import {
  colBase,
  colBase1,
  col,
  col2,
  col3,
  col4,
  col5,
  col6,
  col7,
  col8,
  col9,
  col10,
} from "./Col.module.scss";

export const Col: React.FC<IColProps> = (props) => {
  const _propsClass = props.className || "";
  let _className;

  if (_propsClass.indexOf("col2") != -1) {
    _className = `${col2} ${_propsClass}`;
  } else if (_propsClass.indexOf("col3") != -1) {
    _className = `${col3} ${_propsClass}`;
  } else if (_propsClass.indexOf("col4") != -1) {
    _className = `${col4} ${_propsClass}`;
  } else if (_propsClass.indexOf("col5") != -1) {
    if (_propsClass.indexOf("colBase1") != -1) {
      _className = `${col5} ${colBase1}`;
    } else {
      _className = `${col5} ${_propsClass}`;
    }
  } else if (_propsClass.indexOf("col6") != -1) {
    _className = `${col6} ${_propsClass}`;
  } else if (_propsClass.indexOf("col7") != -1) {
    if (_propsClass.indexOf("colBase1") != -1) {
      _className = `${col7} ${colBase1}`;
    } else {
      _className = `${col7} ${_propsClass}`;
    }
  } else if (_propsClass.indexOf("col8") != -1) {
    _className = `${col8} ${_propsClass}`;
  } else if (_propsClass.indexOf("col9") != -1) {
    _className = `${col9} ${_propsClass}`;
  } else if (_propsClass.indexOf("col10") != -1) {
    _className = `${col10} ${_propsClass}`;
  } else {
    _className = `${col} ${_propsClass}`;
  }
  return <div className={`${_className} ${colBase}`}>{props.children}</div>;
};

export default Col;
